import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-pj-pending-approval-modal',
    templateUrl: './pj-pending-approval-modal.component.html',
    styleUrls: ['./pj-pending-approval-modal.component.scss']
})
export class PjPendingApprovalModalComponent {

    constructor(
        private readonly dialogRef: MatDialogRef<PjPendingApprovalModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            status: string;
            requestId: string;
            message?: string;
        },
        private readonly router: Router
    ) { }

    public close(): void {
        this.dialogRef.close();
        this.router.navigate(['/digital-banking']);
    }

    public goToRequests(): void {
        this.dialogRef.close();
        this.router.navigate(['/digital-banking/pj-members']);
    }
}
